<template lang="html">
  <div class="container">
    <h1>Rare’s candidate opportunities</h1>
  </div>
</template>

<script>

export default {
  name: 'ApplyNowBanner',
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container {
  width: 100%;
  height: 270px;
  background-color: #efefef;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 66px;
}

h1 {
  color: $main-text;
  font-family: Europa-Bold;
  font-size: 64px;
  font-style: normal;
  font-weight: 700;
  line-height: 76px;
  letter-spacing: 0.64px;
}

@media only screen and (max-width: 800px) {
  h1 {
    font-size: 36px;
    line-height: 40px;
    text-align: center;
  }

  .container {
    height: 170px;
    margin-top: -2px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/applyNow/components/ApplyNowBanner.vue